import React, { useState } from 'react';
import { Stepper } from '@operations/shared';
import ViewFreePeriodRequests from './ViewFreePeriodRequests';
import SelectCompanyOrPartner from '../../components/SelectCompanyOrPartner';

const SuspendFreePeriod: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'Select Company or Partner for free period requests',
            content: <SelectCompanyOrPartner />,
            id: 0,
        },

        {
            title: 'All free period requests',
            content: <ViewFreePeriodRequests />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

export default SuspendFreePeriod;
